<template>
  <esg-base-chart max-width="500px">
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart type="bar"
                ref="chart"
                :width=this.width
                :height=this.height
                v-show="!loading"
                :options="chartOptions"
                :series="series"/>
  </esg-base-chart>
</template>

<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  components: { EsgBaseChart },
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '250',
    },
    legend: {
      type: String,
      default: 'bottom'
    },
  },
  data() {
    return {
      loading: false,
      corporations: [],
      series: [],
      chartOptions: {
        chart: {
          fontFamily: 'NanumGothic, serif',
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          },
          events: {
            dataPointSelection: (_1, _2, config) => {
              this.$emit('dataPointSelection', this.corporations[config.dataPointIndex]);
            },
            dataPointMouseEnter: (event) => event.target.style.cursor = 'pointer'
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top'
            }
          },
        },
        xaxis: {
          categories: [],
          crosshairs: { show: false }
        },
        dataLabels: {
          enabled: true,
          formatter: val => this.formatNumber(val, 2),
          style: {
            fontWeight: 'normal',
            colors: ['#000']
          },
          offsetY: -20
        },
        yaxis: {
          show: true,
          labels: {
            formatter: val => this.formatNumber(val, 0),
          },
          title: {
            text: '탄소 집약도 (tCO2/TJ)',
            style: {
              fontSize: 12,
              fontWeight: 'normal'
            }
          }
        },
        tooltip: {
          y: {
            show: true,
            formatter: val => {
              return this.formatNumber(val, 2) + ' tCO2/TJ'
            }
          },
        },
        grid: {
          show: false
        },
        legend: {
          position: this.legend,
        },
        states: {
          active: { filter: { type: 'none', } },
        },
      },
    }
  },
  created() {
    this.fetchData();
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        // Fetch corporations
        this.abortController = new AbortController();
        let response = await axios.get('esg/lca/tables/esg_base_corporation', {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        this.corporations = response.data.list;

        // Fetch data
        let year = new Date().getFullYear();
        let years = [year];
        let corporations = this.corporations.map(corp => corp.code);
        let args = [{
          years,
          corporations,
          groupKeys: ['year', 'corporation_code']
        }];

        let data = new FormData()
        data.append('path', 'esg/carbon_intensity/main');
        data.append('json', JSON.stringify(args));

        response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        if (!response.data.data) {
          this.series = [];
          return;
        }

        let list = JSON.parse(response.data.data)[0].data;

        this.setSeries(list);
        this.setLabels();
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
        this.refreshChart();
      }
    },
    setSeries(list) {
      const data = this.corporations.map(corp => corp.code)
          .map(code => list.find(row => row.corporation_code === code).values);
      this.series.push({
        name: '탄소집약도',
        data
      })
    },
    setLabels() {
      this.chartOptions.xaxis.categories = this.corporations.map(corp => corp.name);
    }
  }
}
</script>